import { matchPath } from 'react-router-dom';
import type { NavItemType } from 'types/menu';

export function isNavItemSelected(item: NavItemType, pathname: string): boolean {
  if (item.children?.some(child => isNavItemSelected(child, pathname))) return true;
  const paths = item.activePaths || [item.link || item.url || ''];
  return paths.some(path => !!path && !!matchPath({ path, end: item.matchEnd ?? path === '/' }, pathname));
}
